import { useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router";

const useScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    // Only scroll to top for 'PUSH' or 'REPLACE' navigations (e.g. clicking a link).
    // For 'POP' (back/forward), let browser handle scroll restoration to the last position.
    if (navigationType === "PUSH" || navigationType === "REPLACE") {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [pathname, navigationType]);
};

export default useScrollToTop;
